import React from "react";

function Environment() {
  return (
    <div>
      {process.env.REACT_APP_HOST_ENV !== "production" && (
        <div className="container">
          <pre>{JSON.stringify(process.env, null, 2)}</pre>
        </div>
      )}
    </div>
  );
}

export default Environment;
